import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";
import card from "./card.png";

export const paydayBonanza = {
  id: "payday-bonanza",
  name: "Payday Bonanza",
  
  colorScheme: {
    tileColors: [
      { background: "#ff4719", text: "#fff" },  // very bright red
      { background: "#e62200", text: "#fff" },  // bright red
      { background: "#b91900", text: "#fff" },  // medium-dark red
      { background: "#8c1300", text: "#fff" },  // dark red
    ],
    overlayPattern: overlay,
    overlayColor: "#8a0f03",  // keeping darker overlayColor
    scratchColor: "#a32609",  // keeping darker scratchColor
    
    controlColor: "#af3c1c",  // keeping darker controlColor
    onControlColor: "#fff",
  },
  
  nameImage: name,
  background: background,
  card: card,
} satisfies GameTheme;